import { createModel } from "nyax";
import { TriggerLog } from "src/models/workflow";
import { EncooSort } from "src/models/_shared";
import { TriggerLogEntityModel } from "src/store/models/entity/triggerLog/entity";
import { createUITableWithPermissionModel } from "src/store/models/ui/_shared";

export const TriggerLogTableUIModel = createModel(
  class extends createUITableWithPermissionModel<TriggerLog, EncooSort>({
    setItems: (getContainer, items) =>
      getContainer(TriggerLogEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) =>
      getContainer(TriggerLogEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(TriggerLogEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { workflowId: string; triggerId: string }) => {
          const { workflowId, triggerId } = payload;
          this._initial({
            initialAction: (pageIndex: number, pageSize: number) =>
              this.dependencies.serviceClient.workflow.listTriggerLogs(
                workflowId,
                triggerId,
                pageIndex,
                pageSize
              ),
          });
        },
      };
    }
  }
);
